import Layout from 'antd/lib/layout/layout'
import styled from 'styled-components'

export const StyledLayout = styled(Layout)`
    height: 100vh;
    overflow-y: scroll;
`
